import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Default locale (pt-BR) loaded eagerly. Other locales lazy-load on demand
// — saves ~50 KB of JSON from the main bundle. Brief render in pt-BR is
// possible for non-pt-BR users until their resource arrives (~200-500 ms
// on 4G); falling back to pt-BR is preferable to showing translation keys.
import ptBR from './locales/pt-BR/translation.json';

const lazyLoaders = {
  'en': () => import('./locales/en/translation.json'),
  'es': () => import('./locales/es/translation.json'),
  'fr': () => import('./locales/fr/translation.json'),
  'zh': () => import('./locales/zh/translation.json'),
  'ar': () => import('./locales/ar/translation.json'),
};

async function ensureResource(lng) {
  if (!lng || lng === 'pt-BR') return;
  if (i18n.hasResourceBundle?.(lng, 'translation')) return;
  const loader = lazyLoaders[lng];
  if (!loader) return;
  try {
    const mod = await loader();
    i18n.addResourceBundle(lng, 'translation', mod.default || mod, true, true);
  } catch (err) {
    console.warn(`[i18n] Failed to load locale "${lng}":`, err);
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { 'pt-BR': { translation: ptBR } },
    fallbackLng: 'pt-BR',
    debug: process.env.NODE_ENV === 'development',

    // Language detection options
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    react: {
      useSuspense: true,
    },
  });

// If the detected language isn't pt-BR, kick off the lazy fetch immediately.
ensureResource(i18n.language);

// Handle RTL for Arabic + load resource on language switch.
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lng);
  ensureResource(lng);
});

export default i18n;
